import User from "../models/user";
import { toJsonObject } from "../utils/utils";
import { API, getList, getResponseList, httpDelete, httpGet, httpPost, httpPut } from "./axios";

async function getUsers(queryData: any) {
    const converter = (json: JSON) => User.fromJson(json);
    return await getResponseList(API.CSMS_USER, '', queryData, converter);
}

export { getUsers };